var $f5d2eaeb2ab02e73$exports = {};
// подключи этот файл внизу перед </body>, чтобы элементы уже были в DOM
const $f5d2eaeb2ab02e73$var$menu = document.querySelector('[data-modal-header]');
const $f5d2eaeb2ab02e73$var$openBtn = document.querySelector('[data-modal-header-open]');
const $f5d2eaeb2ab02e73$var$closeBtn = document.querySelector('[data-modal-header-close]');
if ($f5d2eaeb2ab02e73$var$menu && $f5d2eaeb2ab02e73$var$openBtn && $f5d2eaeb2ab02e73$var$closeBtn) {
    const links = $f5d2eaeb2ab02e73$var$menu.querySelectorAll('.backdrop__link');
    function openMenu() {
        $f5d2eaeb2ab02e73$var$menu.classList.remove('is-hidden');
        document.body.classList.add('no-scroll');
    }
    function closeMenu() {
        $f5d2eaeb2ab02e73$var$menu.classList.add('is-hidden');
        document.body.classList.remove('no-scroll');
    }
    $f5d2eaeb2ab02e73$var$openBtn.addEventListener('click', openMenu);
    $f5d2eaeb2ab02e73$var$closeBtn.addEventListener('click', closeMenu);
    links.forEach((link)=>link.addEventListener('click', closeMenu));
}


//# sourceMappingURL=path0.d0c0366a.js.map
